"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _sourceUpdateStatusManager = require("./sourceUpdateStatusManager");
Object.keys(_sourceUpdateStatusManager).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sourceUpdateStatusManager[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _sourceUpdateStatusManager[key];
    }
  });
});